export const languageEn = {
  reg: 'registration',
  error_404_title: 'Sorry, the page was not found or does not exist.',
  error_404_button_text: 'Go to Main Page',
  error_500_title: 'Server is not available. Try again after 15 minutes.',
  error_500_button_text: 'Go to Main Page',

  field_date_button_label: 'Save',

  prefix_price: '₹',
  days: 'days',

  resend_code_title: 'Re-sending the code is available through',
  resend_code_link_label: 'Resend code',

  registration_progress_title_first: 'Number verification',
  registration_progress_title_second: 'Personal information',
  registration_progress_title_third: 'Receiving money',

  registration_progress_title_percent: '+ {{percent}}% to the probability of loan approval',

  registration_s1_title: 'Contact details',
  registration_s1_description: 'To apply for a loan, enter your phone number',
  registration_s1_f_username_label: 'Phone number',
  registration_s1_button_label: 'Continue',
  registration_s1_agreement:
    'By Signing up, you consent to receive communications from us via email, phone calls, WhatsApp, and SMS, including updates, notifications, and promotional messages. You confirm that you have read, understood, and agree to our <a1>Privacy Policy</a1> and <a2>Terms and Conditions</a2>. Additionally, you agree to override any Do Not Disturb (DND) preferences to ensure you receive important updates and notifications related to our services. ',

  registration_s2_title: 'Phone verification',
  registration_s2_info:
    'We sent you an SMS with the code to the number<br/>' +
    '<span>{{phone}}</span> (<a>change</a>)<br/>' +
    'Please enter the code in the input field below',
  registration_s2_f_code_label: 'SMS code',
  registration_s2_f_agree_label:
    'By clicking "Continue" you agree to the <a1>Terms & Conditions</a1>, <a2>Data privacy policy</a2> and <a3>Fair practice code policy</a3',
  registration_s2_button_label: 'Continue',
  registration_s2_message_info:
    "If you haven't received OTP code please dial <span>*456*9*5*5*1#</span>. After dialing, request for OTP again.",
  registration_s22_title: 'Retrieve your Experian Credit Report and Score',
  registration_s22_description:
    'You hereby consent to LENDPLUS (Aventus Technology India Private Limited) being appointed as\n' +
    '        your authorised representative to receive your Credit Information from Experian for the\n' +
    '        purpose of evaluating your credit worthiness and facilitating customized loan/credit offers\n' +
    '        to you. (“End Use Purpose”). You hereby agree to <a1>Terms & Conditions</a1>.',
  registration_s22_label: 'Accept',
  registration_s22_link: 'Decline',
  registration_s22_modal_description:
    'We cannot continue further for your loan application without your consent',
  registration_s22_modal_link: 'Cancel',

  registration_s3_notify:
    'The fields were filled in automatically. If the entry is correct - press the “Continue”. If\n' +
    '              the data is unreliable - correct it, please',
  registration_s3_title: 'Personal info',
  registration_s3_f_first_name_label: 'First name',
  registration_s3_f_middle_name_label: 'Middle name (optional)',
  registration_s3_f_last_name_label: 'Last name',
  registration_s3_f_id_number_label: 'ID number',
  registration_s3_f_birthday_date_label: 'Birthday date',
  registration_s3_f_gender_label: 'Gender',
  registration_s3_f_pancard_label: 'Pancard number',
  registration_s3_f_education_label: 'Education',
  registration_s3_f_marital_status_label: 'Marital status',
  registration_s3_f_email_label: 'Email',
  registration_s3_f_gender_o_male_label: 'Male',
  registration_s3_f_gender_o_female_label: 'Female',
  registration_s3_f_number_of_children: 'Children (up to 18 years old)',
  registration_s3_f_button_label: 'Continue',

  registration_s3_modal_pc_title: 'Consent to personal data processing',
  registration_s3_modal_pc_description:
    'By activating  this checkbox you agree to the personal data processing',
  registration_s3_modal_pc_button_label: 'Continue',

  registration_s3_modal_got_your_loan: "You've practicaly got your loan!",
  registration_s3_modal_got_your_reg_in_app:
    'To get a loan, continue registration in our app by clicking on the continue button',
  registration_s3_modal_got_your_button_label: 'Continue',

  registration_s31_button_label: 'Get the money',

  registration_employment_title: 'Employment details',
  registration_employment_label_salary_day_in_month: 'Next salary day',
  registration_employment_label_employment_type: 'Employment type',
  registration_employment_label_duration_of_work: 'Duration of work in last place',
  registration_employment_label_monthly_income: 'Monthly income',
  registration_employment_label_main_source_of_income: 'Main source of income',
  registration_employment_title_company_name: 'Company name',
  registration_employment_label_company_name: 'Company name',
  registration_employment_label_company_phone_number: 'Company phone number',
  registration_employment_title_colleague_contact: 'Colleague’s contact',
  registration_employment_label_colleague_contact: 'Colleague’s contact',
  registration_employment_sublabel_colleague_contact: 'Should be 18-60 years old’s contact',
  registration_employment_label_colleague_phone_number: 'Phone number',

  registration_additional_details_title: 'Additional info',
  registration_additional_details_description:
    "To ensure faster credit processing, enter Relative's name. Should be 18-60 years old",
  registration_additional_details_relative_name: "Relative's name",
  registration_additional_details_relative_name_description: 'Should be 18-60 years old',
  registration_additional_details_relative_phone_number: "Relative's mobile phone number",
  registration_additional_details_relationship: 'Relationship',
  registration_additional_details_preferable_language: 'Preferable language for communication',

  registration_permanent_address_title: 'Your permanent address',
  registration_permanent_address_description:
    'The fields were filled in automatically. If the entry is correct - press the “Continue”. If the data is unreliable - correct it, please',
  registration_permanent_address_residential_type_label: 'Residential type',
  registration_permanent_address_state_code_label: 'State',
  registration_permanent_address_pin_code_label: 'PIN-code',
  registration_permanent_address_district_label: 'District',
  registration_permanent_address_street_label: 'Street',
  registration_permanent_address_house_label: 'House',
  registration_permanent_address_flat_label: 'Flat',

  forms_placeholder_select_options: '- select options -',
  forms_placeholder_select_day: '- select salary day -',
  forms_placeholder_select_loan_purpose: 'Loan purpose',
  forms_options_no_matches_found: 'No matches found',
  forms_button_label: 'Continue',

  login_s1_title: 'Log in',
  login_s1_link_to_registration: 'or Register now',
  login_s1_description:
    'Please enter your phone number. You will receive a password to enter your account.',
  login_s1_f_username_label: 'Phone number',
  login_s1_button_label: 'Continue',
  login_s1_agreement:
    'By logging in, you consent to receive communications from us via email, phone calls, WhatsApp, and SMS, including updates, notifications, and promotional messages. You confirm that you have read, understood, and agree to our <a1>Privacy Policy</a1> and <a2>Terms and Conditions</a2>. Additionally, you agree to override any Do Not Disturb (DND) preferences to ensure you receive important updates and notifications related to our services.',

  phone_input_modal_heading: 'Is your phone number ',
  phone_input_modal_description: 'Check if the number is entered correctly',
  phone_input_modal_button: 'Yes, phone number is correct',
  phone_input_modal_link_change: 'Change phone number',

  login_s2_title: 'Log in',
  login_s2_info:
    'We sent you an SMS with the code to the number<br/>' +
    '<span>{{phone}}</span> (<a>change</a>)<br/>' +
    'Please enter the code in the input field below',
  login_s2_f_code_label: 'SMS code',
  login_s2_message_info:
    "If you haven't received OTP code please dial <span>*456*9*5*5*1#</span>. After dialing, request for OTP again.",
  login_s2_button_label: 'Continue',
  login_s2_agreement:
    'By providing OTP, you consent to receive communications from us via email, phone calls, WhatsApp, and SMS, including updates, notifications, and promotional messages. You confirm that you have read, understood, and agree to our <a1>Privacy Policy</a1> and <a2>Terms and Conditions</a2>. Additionally, you agree to override any Do Not Disturb (DND) preferences to ensure you receive important updates and notifications related to our services. ',

  message_username_first_number_no_valid: 'The phone number must start from 9, 8, 7, 6, 5, 4  or 3',
  message_username_required: 'Phone number required',
  message_username_length: 'Phone number should consist of 12 digits including country code',
  message_phone_number_required: 'Phone number required',
  message_phone_number_length: 'Phone number should consist of 12 digits including country code',
  message_password_required: 'SMS code required',
  message_password_length: 'Minimum 4 characters',
  message_confirmation_code_length: 'Minimum 4 characters',
  message_is_data_processing_consent_given_required: 'Mark checkbox to continue the registration.',
  message_is_is_credit_bureau_consent_given: 'Mark checkbox to continue the registration.',
  message_field_required: 'Field is required',
  message_field_required_penny_transfer: 'This field should be filled up',
  message_field_required_penny_transfer_IFSC:
    'Your bank details are not valid. Please check and try again',
  message_confirmation_code_required: 'Confirmation code required',
  message_alpha_numeric_and_symbols: 'You have used prohibited symbol',
  message_adult_date_range: 'Your age must be over 21 and under 55',
  message_invalid_date: 'Invalid date',
  message_invalid_ifsc_code:
    'The IFSC code consists of first latin letters, then zero and 6 symbols',
  message_invalid_birthday_date: 'Please check your birthday date',
  message_aadhar_field_length: 'Aadhaar number should consist of 12 digits',
  message_aadhaar_otp_length: 'Min 6 digits',
  message_aadhaar_otp_required: 'Confirmation code required',
  message_min_twelve_length: 'Phone number should consist of 12 digits including country code',

  account_side_bar_content_title: 'Account',
  account_header_link_application: 'Credit',
  account_header_link_credit_history: 'Credit history',
  account_header_link_payment_history: 'Payment history',
  account_header_link_personal_information: 'Personal information',
  account_header_link_logout: 'Logout',
  account_header_link_login: 'Login',

  account_active_credit_title: 'Active',
  account_active_credit_description: 'Total sum for repayment',
  account_active_credit_state_title: 'Status',
  account_active_credit_state_days_till_date: '{{daily}} days till payment',
  account_active_credit_state_today_is_payment_date: 'Today is the payment day',
  account_active_credit_state_overdue: 'Overdue {{daily}} days',
  account_active_credit_state_next_payment: 'Next payment {{daily}} ({{dayOfWeek}})',
  account_active_credit_state_payment_date_was: 'Payment date was {{daily}} ({{dayOfWeek}})',
  account_active_credit_price_body: 'Loan amount',
  account_active_credit_principal_due: 'Principal due',
  account_active_credit_price_service: 'Service fee',
  account_active_credit_price_service_gst: 'GST on service fee',
  account_active_credit_accrued_processing_fee: 'Processing Fee ',
  account_active_credit_accrued_processing_fee_gst: 'Processing Fee + GST',
  account_active_credit_price_interest_fee: 'Interest fee ',
  account_active_credit_interest_fee: 'Interest',
  account_active_credit_body: 'Body',
  account_active_credit_price_total: 'Total outstanding',
  account_active_credit_payment_today: 'Next payment',
  account_active_credit_need_to_repay_title: 'Make the minimum payment',
  account_active_credit_need_to_repay_description:
    'You requested a loan under the following conditions',
  account_active_credit_need_to_repay_date: 'till {{date}}',
  account_active_credit_need_to_repay_button: 'Payment now',
  account_active_credit_repayment_title: 'Repayment amount',

  account_active_credit_repayment_options: 'Repayment options',
  account_active_credit_repayment_button: 'Repay {{prefix}} {{amount}}',
  account_active_credit_total_amount: 'Total',
  account_active_credit_interest_fee_plus_gst: 'Upfront fee + GST',
  account_active_credit_upfront_interest_fee_plus_gst: 'Upfront fee + GST',
  account_active_credit_progress_interest_fee_plus_gst: 'Processing fee + GST',
  account_active_credit_service_interest_fee_plus_gst: 'Service fee + GST',
  account_active_credit_late_payment_fee_gst: 'Late payment fee + GST',
  account_active_credit_bounce_fee_gst: 'Bounce fee + GST',
  account_active_credit_send_link: 'Send the link for payment to your friends or family member',
  account_active_credit_or: 'or',
  account_active_app_price_payment_schedule_name: 'Name',
  account_active_app_price_payment_schedule_accrued: 'Accrued',
  account_active_app_price_payment_schedule_paid: 'Paid',
  account_active_app_price_payment_schedule_need_to_pay: 'Need to pay',
  account_active_app_price_payment_schedule_choose_payment_option: 'Сhoose payment option',
  account_active_app_payment_notification:
    'Pay attention that your credit rate influences your future ability to get a new loan, it decreases according to amount overdue days. We will pass this information to CB',

  calculator_app_title: 'Apply for a loan',
  calculator_app_description: 'You have no active loans at the moment',
  calculator_app_bank_title: 'Transfer to MPESA:',
  calculator_app_slider_amount_label: 'Loan amount',
  calculator_app_slider_term_label: 'Loan term',
  calculator_app_price_amount: 'Loan amount',
  calculator_app_price_date: 'Payment date',
  calculator_app_price_term: 'Loan term',
  calculator_app_price_days: 'days',
  calculator_app_price_total: 'Full repayment amount',
  calculator_app_price_service_fee: 'Service fee',
  calculator_app_price_payment_schedule: 'Payment Schedule',
  calculator_app_price_payment_schedule_n: '№',
  calculator_app_price_payment_schedule_date: 'Date',
  calculator_app_price_payment_schedule_amount: 'Amount',
  calculator_app_price_payment_schedule_repayment_sum: 'Repayment sum',
  calculator_app_price_payment_schedule_repaid: 'Repaid ',
  calculator_app_price_payment_schedule_need_to_repay: 'Need to repay ',
  calculator_app_button_label: 'Apply for a loan',
  calculator_app_promo_init_link: 'Enter promo code',
  calculator_app_promo_exit_link: 'Enter promo code',
  calculator_app_promo_input_placeholder: 'Enter promo code',
  calculator_app_promo_button_label: 'Apply',
  calculator_app_promo_error: 'Promo code is invalid',
  calculator_app_promo_required: 'Promocode to get a discount',
  calculator_app_promo_active: 'Discount code activated',
  calculator_app_promo_not_active: 'Discount code not activated',
  calculator_app_promo_active_link: 'Enter another promocode',

  account_personal_bank_account:
    '<p><span>Bank account: </span> {{bank_account_number}}{{bank_name}}</p>',
  account_personal_ifsc_code: '<p><span>IFSC code: </span> {{value}}</p>',
  account_personal_email: '<p><span>E-mail: </span> {{value}}</p>',
  account_personal_id_card: '<p><span>Personal ID: </span> {{value}}</p>',
  account_personal_phone: '<p><span>Phone number: </span> {{value}}</p>',
  account_personal_address: 'Address: ',
  account_personal_support_title: 'Change information',
  account_personal_support_description:
    'To change your phone number and other personal data please contact our contact center',
  account_personal_download: 'Download',
  account_personal_open_dispute: 'Open Consumer dispute',

  account_payments_date: 'Payment date',
  account_payments_contract: 'Contract number',
  account_payments_amount: 'Payment amount',
  account_payments_not: 'No payment information',

  account_credit_history_state_active: 'Active',
  account_credit_history_state_defaulted: 'Defaulted',
  account_credit_history_state_pending: 'Pending',
  account_credit_history_state_close: 'Closed',
  account_credit_history_state_sold: 'Sold',
  account_credit_history_state_overdue: 'Overdue',
  account_credit_history_contract_number: '№',
  account_credit_history_disbursement_date: 'Disbursement date',
  account_credit_history_loan_sum: 'Loan sum',
  account_credit_history_term: 'Term',
  account_credit_history_payments: 'Payments',
  account_credit_history_documents: 'Documents',
  account_credit_history_status: 'Status',
  account_credit_history_more_payment_info: 'more',
  account_credit_history_not: 'No credit history information',

  account_contract_signing_esign_title:
    'Sign a loan agreement with your E-Aadhar signature, please',
  account_contract_signing_esign_subtitle: '',
  account_contract_signing_esign_button_text: 'Sign up',

  account_contract_first_loan_signing_agreement: 'Signing Loan Agreement',
  account_contract_first_loan_signing_sanction_letter: 'Signing Loan Application, Sanction Letter',
  account_contract_repeat_loan_signing_otp_title:
    'Signing Loan Agreement, Loan Application, Sanction Letter',
  account_contract_signing_otp_subtitle: `<p>We will send you an SMS with the code to the <br> number {{value}}. <br>Please, press the button below to send SMS</p>`,
  account_contract_enter_otp_subtitle: `<p>We have sent you an SMS with the code to the <br>  number {{value}}. <br>Please enter the code in the input field below in order to sign the agreement</p>`,
  account_contract_signing_otp_button_text: 'Sign',

  account_contract_signing_otp_wait_sms_subtitle: `<p>We have sent you an SMS with the code <br> to the number {{value}}. <br> Please enter the code in the input field below in order to sign the agreement</p>`,
  account_contract_signing_otp_wait_sms_button_text: 'Sign up',

  account_contract_signing_agreement_link: 'Loan agreement',
  account_contract_signing_agreement_and_sanction_letter_link: 'Loan Application, Sanction Letter',

  account_setup_auto_debit_heading: 'Setup auto debit',
  account_setup_auto_debit_description:
    "After clicking on the “Setup” button, you will be redirected to Cashfree's third-party payment provider",
  account_setup_auto_debit_button_text: 'Setup',
  account_setup_auto_debit_error_message:
    'Service unavailable. You can proceed with auto-debit later.',
  account_setup_auto_debit_info:
    'Your repayment will be auto-debited from your bank account on your due date. Auto-debit is a process where in your loan repayment will debit from your bank account automatically',

  account_confirmation_conditions_heading: 'Confirmation of conditions',
  account_confirmation_conditions_description:
    'To complete the application process, please confirm the loan conditions',
  account_confirmation_conditions_transfer_to_mpesa: 'Transfer to MPESA',
  account_confirmation_conditions_loan_term: 'Loan term',
  account_confirmation_conditions_loan_amount: 'Loan amount',
  account_confirmation_conditions_interest_amount: 'Interest amount',
  account_confirmation_conditions_payment_date: 'Payment date',
  account_confirmation_conditions_total_outstanding: 'Total outstanding',
  account_confirmation_conditions_payment_amount: 'Payment amount',
  account_confirmation_conditions_payment_schedule: 'Payment schedule',
  account_confirmation_conditions_extension_at: 'Extension at',
  account_confirmation_conditions_late_payment_fee: 'Late payment fee',
  account_confirmation_conditions_days: 'days',
  account_confirmation_conditions_agree_label: 'I agree with <a1>Terms&Conditions</a1>',
  account_confirmation_conditions_button_text: 'Continue',
  account_confirmation_conditions_customer_change_condishions: 'Change',
  account_confirmation_conditions_customer_complaint_text_popup: `
  1) If Customer has a question or complaint, he/she can call to the Lendplus Customer Care line +25 47 1911 6436.\n                                 
  2) The Customer Care Representative will listen & then take an appropriate action in order to
respond/ close the issue.\n                     
  3) If the Issue has not been resolved within 24 hours, a customer can either contact a Customer Care line again or contact the Technical support team at +25 47 1911 6436, customer@lendplus.ke
  `,
  account_confirmation_conditions_percent_text: '% per day',
  account_confirmation_conditions_payment_schedule_popup: 'this is payments schedule table',

  account_submit_calculator_button_text: 'Apply for a loan',

  account_approved_modal_heading: 'Why are you not satisfied with the loan terms?',
  account_approved_modal_description: 'Please, tell to us',
  account_approved_button_text: 'Get money',
  account_approved_link_text: 'Not satisfied with the loan terms',
  account_approved_form_button_text: 'Send feedback',
  account_approved_form_link_text: 'Back to the Loan terms',
  account_approved_form_radio_label: 'List of reasons',
  account_approved_form_text_label: 'Your comment',
  account_approved_partner_text: 'Loan offer from our partners',
  account_approved_partner_button_text: 'Apply',

  accordion_more_details: 'More details',

  bank_account_title: 'Bank account details',
  change_bank_account_title: 'Change bank account details',
  money_transfer: 'Money will be transferred to your bank account',
  bank_account_description_ifscCode: `Please enter your IFSC code`,
  new_bank_account_description_ifscCode: `Please enter your new IFSC code`,
  bank_account_description_bankCode: `Please enter your bank account number`,
  new_bank_account_description_bankCode: `Please enter your new bank account number`,
  bank_account_link: 'Add Bank info manually',
  bank_account_label_bank_account: 'Bank account number',
  bank_account_label_ifsc_code: 'IFSC code',
  bank_account_label_ifsc_change: 'Change',

  bank_account_statement_title: 'Account statement',
  bank_account_statement_description:
    'Please provide the consent for your finance data. This will help speed up the processing of your application, and you will also be able to receive personalized loan terms.',
  bank_account_statement_continue_register: 'Now you can continue to register',

  bank_account_statement_info1: `Pay attention!<br>
    Select the bank account number, that was filled in on previous step.
    <br><br>
    <p>We understand the importance of your privacy and security. Rest assured, your information is encrypted and securely stored.</p>
`,
  bank_account_statement_info2: `If you are unable to share the data, you can try again by clicking on the <strong>{{text_continue}}</strong> button or go to the next step by clicking on <strong>{{text_setup}}</strong>`,

  bank_account_setup: 'Setup account aggregator',
  bank_account_share: 'Share finance data',
  bank_account_setup_again: 'Try again setup',
  bank_account_statement_loader_description:
    'Please share the Account statement and wait until we have processed the data',
  bank_account_statement_loader_button: 'Continue',

  bank_statement_upload_title: 'Bank statement upload',
  bank_statement_upload_description: 'Share 6 month bank statement by logging to netbanking',
  bank_statement_upload_description_2:
    'Bank statement can be dated till -1 day at the date of upload',
  bank_statement_upload_info_1:
    'To ensure faster credit process please choose one of the options below',
  bank_statement_upload_info_2: 'Upload your 6 month bank statement',
  bank_statement_upload_button_1: 'Continue',
  bank_statement_upload_button_2: 'Upload',
  bank_statement_upload_cancel: 'Cancel',
  bank_statement_cancel_changes: 'Cancel changes',

  cashfree_description_wait_redirect_text: 'Please wait to redirect to CashFree',
  cashfree_description_payment_success_text: 'Payment has been completed',
  cashfree_description_payment_error_text: 'The payment was not completed',
  cashfree_description_wait_payment_data_text: 'Please wait to payment data...',
  cashfree_description_loan_is_payment_text: 'This loan is already closed',
  cashfree_description_wait_payment_text:
    'Please wait for the payment to be completed via CashFree',
  cashfree_modal_description_text: 'Are you planning to make a payment on behalf of someone else?',
  cashfree_try_payment_again_text: 'Try payment again',
  cashfree_go_to_main_page_text: 'Go to main page',

  box_loader_default_description: {
    please_wait: 'Please wait to loading data...',
    please_wait_request: 'Please wait for your request to be processed...',
  },

  bad_length_name: 'Field length is incorrect',
  min_2_length: 'Min 2 characters are required',
  min_5_length: 'Min 5 characters are required',
  max_128_length: 'Max 128 characters are required',
  bad_length_id_number: 'Id number length is incorrect',
  bad_format_date: 'Format date is incorrect',

  document_upload_title: 'Document upload',
  document_upload_description:
    'To finalize your application process, please upload your selfie\n photography',
  document_selfie_description: 'To continue your application process, please take a photo-selfie.',
  message_upload_photo_required: 'Upload photo required',
  experian_title: 'We have almost verified your application',

  experian_description: 'To give you a final decision we need on access to your credit history',
  experian_button: 'Continue',
  experian_otp_title: 'Credit history access',

  experian_otp_description: 'To provide access - enter the code from SMS',

  upload_photo_selfie_title: 'Selfie',

  upload_photo_selfie_liveness_title: 'Photo-selfie',
  upload_photo_selfie_liveness_description:
    'To continue your application process, please take a photo-selfie.',

  upload_photo_title_pancard: 'PAN Card photo',
  upload_photo_heading_pancard: 'PAN Card front',
  upload_photo_description:
    'To continue your application process, please take a photo of your PAN Card front.',
  upload_photo_pancard_description: `<p>Take a photo of the front of the PAN Card front so that all the data is clearly visible.</p>
  <ul>
    <li><span>Only photo of original document</span></li>
    <li><span>Make sure that the document well lit and clearly visible</span></li>
  </ul>
`,
  upload_photo_heading_pancard_and_selfie: 'Selfie',
  upload_photo_pancard_and_selfie_description: `<p>To finalize your application process, please take a photo</p>
  <ul>
    <li><span>The photo is clear and well lit</span></li>
    <li><span>Remove mask, sunglasses, hat, etc</span></li>
  </ul>
`,
  upload_photo_heading_aadharcard: 'Aadhaar card font',
  upload_photo_heading_aadharcard_description:
    'Take a photo of the front of the Aadhaar card so that all the data is clearly visible',
  upload_photo_heading_aadharcard_and_selfie: 'Selfie with Aadhaar card',
  upload_photo_heading_aadharcard_and_selfie_description:
    'Take a selfie with photo of the Aadhaar card so that all the data is clearly visible',
  upload_photo_select_a_file: 'Select a file',
  upload_photo_select_another_file: 'Select another file',
  upload_photo_select_take_a_photo: 'Take a photo',
  upload_photo_select_take_another_photo: 'Take another photo',

  photo_or_scanned_pancard_front_side_modal_title: 'Pancard front',
  photo_or_scanned_pancard_modal_text:
    'Take a photo of the front of the Pancard so that all the data is clearly visible',

  photo_or_scanned_pancard_and_selfie_front_side_modal_title: 'Selfie',
  photo_or_scanned_pancard_and_selfie_modal_text:
    'Take a selfie with photo of the front of the Pancard so that all the data is clearly visible',

  photo_or_scanned_aadharcard_front_side_modal_title: 'Aadhar card front',
  photo_or_scanned_aadharcard_modal_text:
    'Take a photo of the front of the Aadhar card so that all the data is clearly visible',

  photo_or_scanned_aadharcard_and_selfie_front_side_modal_title: 'Selfie with Aadhar card',
  photo_or_scanned_aadharcard_and_selfie_modal_textphoto_or_scanned_aadharcard_and_selfie_modal_text:
    'Take a selfie with photo of the front of the Aadhar card so that all the data is clearly visible',

  photo_button_name: 'Continue',

  min_length_field: 'Invalid field length. You entered {from} from {to} characters',
  invalid_field: 'Invalid field',

  approved_app_title: 'Your application approved successfully',
  approved_app_subtitle: `<p>We happy to provide you with a loan amount of ₹{{principal}} for a period {{tenor}} days</p>`,
  approved_app_subtitle_is_feedback_send: 'You still have time to think about the terms',
  approved_app_alert: `<p>The offer is valid <strong>{{days}} days : {{hours}} hours : {{minutes}} minutes </strong></p>`,
  approved_app_principal: 'Disbursed amount',
  approved_app_interest_fee: 'Interest fee',
  approved_app_processing_fee_and_gst: 'Processing fee + GST',
  approved_app_settlement_amount: 'Total repayment amount',
  approved_app_maturity_date: 'Repayment date',

  pending_app_title: 'Your application is pending',
  pending_app_subtitle: `<p>The application review may take from 15 minutes to 12 hours</p> <br /><p>Working hours: {{value}}</p>`,
  pending_app_info_message: `<p>We will inform you about the solution by SMS.</p> <p>If you need help call us please <a>{{value}}</a></p>`,

  pending_auto_debit_app_title: 'You subscription is being activated by the bank',
  pending_auto_debit_app_subtitle: ``,
  pending_auto_debit_app_info_message: `<p>We will inform you about the decision by SMS</p>`,

  reject_app_title: 'Unfortunately, your application was declined',
  reject_app_description: 'Ability to submit a new application is not available in our service',
  reject_app_info: 'Thanks greatly for choosing our service',

  moratorium_app_title: 'Sorry, your application has been rejected',
  moratorium_app_info: 'You can apply for a new loan in:',
  moratorium_app_info_message: 'We will inform you about the decision by SMS',
  moratorium_app_info_message_take_from_partners: 'You can try to take a loan from our partners',
  moratorium_app_try_now: 'Try now',

  money_on_way_app_title: 'Expect. Money is on the way',
  money_on_way_app_description:
    'It usually takes 5-10 min until the money is deposited to your account.',
  money_on_way_app_subtitle: 'Leave feedback on our service',
  money_on_way_app_sub_description: 'Are you satisfied with our service?',
  money_on_way_app_modal_feedback_title: "Aren't you satisfied with our service?",
  money_on_way_app_modal_content:
    'If you are not satisfied with the service, please, send your feedback to care@lendplus.in. We will connect with you to look into the situation more carefully and improve the service',
  money_on_way_app_button_yes: 'Contact us',
  money_on_way_app_button_no: 'Canceled',

  no_service_title: 'Thank you for showing interest for your loan request',
  no_service_description: 'We have not yet started service in your location',
  no_service_description_2:
    'We will inform you on your verified number once we commence service in your location so that you allow us to serve you with your loan request',

  wrong_age_title: 'Thank you for showing interest for your loan request',
  wrong_age_description:
    'Thank you for showing interest in loan request. According to our policy we do not issue loans to citizens ',
  wrong_age_under: 'under {{birthday}} years',
  wrong_age_older: 'who are older than {{birthday}} years',

  black_list_app_title:
    'Unfortunately, ability to submit a new application is not available in our service.',
  black_list_app_description: 'Thanks greatly for choosing our service',
  browser_settings: 'Go to settings and allow access to the camera',

  error_message_an_error_occurred: 'An error occurred. Please, try again.',
  error_message_temporary_unavailable:
    'The service is unavailable now. Our service is temporarily undergoing an improvement process and is technically unable to check your application. As soon as we restart approval of new applications, we will send you a message',
  error_message_an_cannot_change_bank_details:
    'Sorry, we can`t change your bank account, please try again',
  error_message_bank_account_used: 'This bank account number is already used.',
  error_message_loan_is_approved:
    'Your loan application is preliminarily approved! Setup auto debit to complete your loan application process.',
  error_message_service_is_not_available:
    'Service is not available now, please try again in a few minutes',
  error_message_sign_a_loan_agreement_with_e_aadhar:
    'Sign a loan agreement with your E-Aadhar signature, please',
  error_message_aadhaar_number_is_not_valid:
    'Aadhaar number is not valid, please use the correct Aadhaar number',
  error_message_selfie_not_uploaded: 'Selfie not uploaded. Please try again',
  error_message_pancard_not_uploaded: 'PAN Card photo not uploaded. Please try again',
  error_message_otp_validation_failed: 'OTP validation failed, OTP is not match. Please try again',
  error_message_no_pending_request_found: 'No pending request found. Please, try again.',
  error_message_no_post_consent_request: 'Request not sending. Please, try again.',
  success_message_an_change_bank_details: 'Your bank account successfully changed',

  modal_change_phone_heading: 'Change phone number',
  modal_change_phone_description: 'Enter the new phone number you want to change to',

  subscription_page_heading: 'Subscription created successfully',
  subscription_page_description: 'You will be redirected to the next step to sign the contract',

  custom_payment_info_text_en:
    '            Pay your loan today, either before or on the due date. If you pay on time, you can get a\n' +
    '            new loan within 15 minutes. It can be a new loan or the replacement of the existing one.\n' +
    '            Paying on-time helps to improve your credit score and will let you borrow more in the\n' +
    '            future.',
  custom_payment_info_text_in:
    '            आज ही अपना पूरा ऋण भुगतान करें, या तो तारीख से पहले या समय पर। जल्दी या समय पर भुगतान\n' +
    '            करने पर आप 15 मिनट में एक नया ऋण ले सकते हैं। यह नया ऋण हो सकता है या आपके हाल ही में\n' +
    '            भुगतान किए ऋण का प्रतिस्थापन। समय पर भुगतान करने से आपके क्रेडिट स्कोर में सुधार होगा और\n' +
    '            यदि आप समय पर भुगतान करते रहते हैं तो भविष्य में आपकी ऋण सीमा बढ़ सकती है.',

  metas: {
    registration: {
      title: 'Registration and processing of Lendplus loan',
      description: 'Registration in the Lendplus service to apply for a loan',
      canonical: 'https://lendplus.in/registration',
    },
    login: {
      title: 'Login to Lendplus personal account',
      description: 'Lendplus Client Cabinet. Information about your loans',
      canonical: 'https://lendplus.in/login',
    },
  },
};
